import { render, staticRenderFns } from "./createPaymentModal.vue?vue&type=template&id=bf1052b2&scoped=true&"
import script from "./createPaymentModal.vue?vue&type=script&lang=js&"
export * from "./createPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./createPaymentModal.vue?vue&type=style&index=0&id=bf1052b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1052b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf1052b2')) {
      api.createRecord('bf1052b2', component.options)
    } else {
      api.reload('bf1052b2', component.options)
    }
    module.hot.accept("./createPaymentModal.vue?vue&type=template&id=bf1052b2&scoped=true&", function () {
      api.rerender('bf1052b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/createPaymentModal.vue"
export default component.exports